<template>
  <v-container>
    <v-row v-if="orderrItemGroup != null">
      <v-col class="col-12 col-md-4">
        <v-img
          v-if="$vuetify.breakpoint.smAndDown"
          class="align-end"
          :src="productImage"
          height="150"
          gradient="to bottom, rgba(0,0,0,.01), rgba(0,0,0,.1)"
        ></v-img>
        <v-img
          v-else
          class="align-end"
          :src="productImage"
          :aspect-ratio="0.6"
          gradient="to bottom, rgba(0,0,0,.01), rgba(0,0,0,.1)"
        ></v-img>
      </v-col>

      <v-col class="col-12 col-md-8">
        <v-row>
          <v-col>
            <h2 class="subtitle-1">{{ location.title }}</h2>
            <h1 class="display-1">
              {{ orderrItemGroup.product.title }}
              {{ orderrItemGroup.product.skill.title }}
              {{ orderrItemGroup.product.skill.mssId }}
            </h1>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-stepper v-model="stepperModel" vertical flat>
              <v-stepper-step
                :complete="stepperModel > 1"
                :editable="stepperModel > 1"
                step="1"
              >
                <template v-if="skillLevelClient">
                  {{ $t(skillLevelClient) }}
                </template>
                <template v-else>
                  Úroveň
                  <small>Jak dobře už umíte jezdit?</small>
                </template>
              </v-stepper-step>

              <v-stepper-content step="1">
                <div>
                  <v-radio-group
                    v-model="skillLevelClient"
                    @change="stepperModel = 2"
                  >
                    <v-radio :label="$t('BEGINNER')" value="BEGINNER"></v-radio>
                    <v-radio
                      :label="$t('INTERMEDIATE')"
                      value="INTERMEDIATE"
                    ></v-radio>
                    <v-radio :label="$t('ADVANCED')" value="ADVANCED"></v-radio>
                    <v-radio
                      :label="$t('EXPERIENCED')"
                      value="EXPERIENCED"
                    ></v-radio>
                  </v-radio-group>
                </div>
                <v-btn
                  color="primary"
                  @click="stepperModel = 2"
                  :disabled="!skillLevelClient"
                >
                  Další
                </v-btn>
              </v-stepper-content>

              <v-stepper-step
                :complete="stepperModel > 2"
                :editable="stepperModel > 2"
                step="2"
              >
                <template v-if="languages.length > 0">
                  {{ languageLabel }}
                </template>
                <template v-else>
                  Jazyk výuky
                  <small>Jaký je váš preferovany jazyk výuky?</small>
                </template>
              </v-stepper-step>

              <v-stepper-content step="2">
                <div>
                  <v-checkbox
                    value="CS"
                    v-model="languages"
                    :label="$t('CS')"
                  ></v-checkbox>
                  <v-checkbox
                    value="SK"
                    v-model="languages"
                    :label="$t('SK')"
                  ></v-checkbox>
                  <v-checkbox
                    value="EN"
                    v-model="languages"
                    :label="$t('EN')"
                  ></v-checkbox>
                  <v-checkbox
                    value="DE"
                    v-model="languages"
                    :label="$t('DE')"
                  ></v-checkbox>
                </div>
                <v-btn color="primary" @click="stepperModel = 3"> Další </v-btn>
              </v-stepper-content>

              <v-stepper-step
                :complete="stepperModel > 3"
                :editable="stepperModel > 3"
                step="3"
              >
                <template v-if="stepperModel > 3">
                  {{ $t("Delka") }}: {{ lengthSum }} {{ $t("hod.") }} |
                  {{ $t("Pocet_lekci") }}: {{ eventsCount }}
                </template>
                <template v-else>
                  Kalendář lekcí
                  <small>Kdy chcete být na svahu?</small>
                </template>
              </v-stepper-step>

              <v-stepper-content step="3">
                <!-- (14 x 48 = 672) + 80 = 752 -->
                <course-private-calendar
                  v-if="
                    stepperModel == 3 &&
                    languages != null &&
                    languages.length > 0 &&
                    skillLevelClient != null
                  "
                  :product="orderrItemGroup.product"
                  :checkInDate="checkInDate"
                  :languages="languages"
                  :skillLevelClient="skillLevelClient"
                  @change:lessons="lessonsChangeHandler"
                  :numberOfHoursRequired="numberOfHoursRequired"
                >
                </course-private-calendar>

                <p>
                  {{ $t("Delka") }}:
                  <span class="font-weight-black subtitle-1">
                    {{ lengthSum }} {{ $t("hod.") }}
                  </span>
                  | {{ $t("Pocet_lekci") }}:
                  <span class="font-weight-black subtitle-1">
                    {{ eventsCount }}
                  </span>
                </p>

                <v-btn
                  color="primary"
                  @click="stepperModel = 4"
                  :disabled="eventsCount == 0"
                >
                  Potvrdit vybrané lekce
                </v-btn>
              </v-stepper-content>

              <v-stepper-step
                :complete="stepperModel > 4"
                :editable="stepperModel > 4"
                step="4"
              >
                Koho budeme učit?
              </v-stepper-step>

              <v-stepper-content step="4">
                <course-person
                  v-for="(p, index) in coursePersons"
                  v-model="coursePersons[index]"
                  v-bind:key="index"
                ></course-person>
              </v-stepper-content>

              <!-- <v-stepper-step
                :complete="stepperModel > 3"
                :editable="stepperModel > 3"
                step="3"
              >
                Počet hodin
                <small></small>
              </v-stepper-step>

              <v-stepper-content step="3">
                <div>
                  <p>
                    Kolik hodin výuky chcete absolvovat? Vybereme vám podle toho
                    instruktora/instruktorku.
                  </p>
                  <ul class="mv-3">
                    <li>1 hodina je vhodná pro malé děti do 4 let.</li>
                    <li>
                      2 hodiny jsou minimum pro starší děti a dospěláky. Dobré,
                      když zkoušíte něco nového, ale nevíte, co od toho čekat.
                    </li>
                    <li>
                      2-4 hodiny jsou optimální rozsah pro zdokonalovací jízdy
                      pro ty, co už trochu jezdí.
                    </li>
                    <li>
                      4 hodiny by měli stačit pro úplného začátečníka, aby sjel
                      mírný kopec. Na vleku však jezdit asi nebudete.
                    </li>
                    <li>
                      8 hodin je pro úplného začátečníka optimum, aby sjel mírný
                      svah, naučil se na vleku a zažil si jízdu tak, aby si to
                      pamatoval do příští zimy.
                    </li>
                  </ul>
                </div>
                <v-btn color="primary" @click="stepperModel = 4">
                  Naplánovat lekce
                </v-btn>
                <v-btn text>
                  Cancel
                </v-btn>
              </v-stepper-content> -->
            </v-stepper>
          </v-col>
        </v-row>

        <v-row v-if="orderrItemGroup != null">
          <!-- pravy panel s rekapitulaci polozky -->
          <v-col class="mb-10">
            <price-summary
              :price="orderrItemGroupPrice"
              :deposit="deposit"
            ></price-summary>

            <v-btn
              block
              class="primary"
              :loading="submiting"
              :disabled="bookItemDisabled"
              @click="bookItem"
            >
              Rezervovat</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- notifikace - polozka pridana do kosiku -->
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="550">
        <v-card>
          <v-card-title class="headline">
            <v-icon color="green"> mdi-checkbox-marked </v-icon>
            Položka byla přidána do košíku
          </v-card-title>
          <v-card-text
            >Na dokončení rezervace máte
            {{ mobConfig.checkoutTimeLimit }} minut.</v-card-text
          >
          <v-card-actions>
            <v-btn @click="goToCourseSearch" text> Pokračovat </v-btn>
            <v-btn @click="goToCart" text> Košík </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import APIAdapter from "../store/APIAdapter";
import CoursePrivateCalendar from "@/components/CoursePrivateCalendar";
import CoursePerson from "@/components/CoursePerson";
import PriceSummary from "@/components/PriceSummary";
import moment from "moment";
import PriceCalculator from "@/libs/PriceCalculator";

export default {
  metaInfo: {
    title: "Rezervace privatni vyuky",
  },

  components: {
    CoursePrivateCalendar,
    CoursePerson,
    PriceSummary,
  },

  data() {
    return {
      orderrItemGroup: null,
      dialog: false,
      submiting: false,
      stepperModel: 1,
      skillLevelClient: null,
      languages: [],
      numberOfHoursRequired: 5,
      selectedLessons: [],

      coursePersons: [],
    };
  },

  async mounted() {
    console.log("mounted");

    if (
      this.$store.state.location == null ||
      this.$store.state.appInstance == null ||
      this.$store.state.checkInDate == null
    ) {
      console.log("Nesplnene prerekvizity");
      this.$router.push({ name: "course" });
    } else {
      this.init();
    }
  },

  computed: {
    mobConfig() {
      return this.$store.state.mobConfig;
    },

    oigDescription() {
      if (this.coursePersons == null || this.coursePersons.length == 0) {
        return null;
      }

      let description = [];
      for (let i = 0; i < this.coursePersons.length; i++) {
        let p = this.coursePersons[i];
        let des = [];
        if (p.name != null && p.name.trim() != "") {
          des.push(p.name);
        }
        if (p.age != null && p.age.trim() != "") {
          des.push(p.age + " " + this.$t("let"));
        }
        description.push(des.join(", "));
      }
      //return this.coursePersons;
      return description.join("; ");
    },

    bookItemDisabled() {
      if (this.currentOrderr == null) {
        return !this.orderrItemGroupValid || this.lengthSum == 0;
      } else {
        return (
          !this.orderrItemGroupValid ||
          this.currentOrderrExpired ||
          this.lengthSum == 0
        );
      }
    },

    productImage: function () {
      if (this.orderrItemGroup.product.images == undefined) {
        return null;
      }
      if (this.orderrItemGroup.product.images.length < 1) {
        return null;
      }
      return this.orderrItemGroup.product.images[0];
    },

    productId() {
      console.log("computed - productID");

      return this.$route.params.productId;
    },

    location() {
      return this.$store.state.location;
    },

    languageLabel() {
      return this.languages.map((l) => this.$t(l)).join(", ");
    },

    currentOrderrExpired() {
      return this.$store.state.currentOrderrExpired;
    },

    currentOrderr() {
      return this.$store.state.currentOrderr;
    },

    dateStartFormated() {
      return "zacatek";
    },

    dateEndFormated() {
      return "konec";
    },

    orderrItemGroupPrice() {
      return PriceCalculator.findPrice(
        this.orderrItemGroup.product.priceTables,
        this.orderrItemGroup.priceListType,
        this.lengthSum > 0 ? this.lengthSum : 1,
        this.orderrItemGroup.numberOfPersons,
        this.mobConfig.schoolDiscountPercent
      );
    },

    orderrItemGroupValid() {
      return true;
    },

    checkInDate() {
      return this.$store.state.checkInDate;
    },

    lengthSum() {
      let length = 0;
      for (let i = 0; i < this.selectedLessons.length; i++) {
        let e = this.selectedLessons[i];
        let l = moment(e.end).diff(moment(e.start), "hour");
        length += l;
      }
      return length;
    },

    eventsCount() {
      return this.selectedLessons.length;
    },
  },

  methods: {
    async init() {
      // zkontrolovat, jesli jsem prihlasen
      if (this.$store.state.user == null) {
        this.$emit("loginRequest");
        return;
      }

      if (this.productId == null) {
        throw "Product ID is NULL";
      }

      // produkt plus default article
      let product = await APIAdapter.getProduct(this.productId);
      console.log("produkt");
      console.log(product);

      console.log("this.location");
      console.log(this.location);
      let defaultPointSell = this.location.pointSells.items[0];

      console.log("defaultPointSell");
      console.log(defaultPointSell);

      let articles = await APIAdapter.listArticlesByProductAndPointSell(
        product.id,
        defaultPointSell.id
      );

      if (articles.length == 0) {
        console.error("Nebyl nalezen article pro produkt vyuky");
        return;
        // TODO: vyhodit hlasku, reportovat
      }

      let defaultArticle = articles[0];

      let oi = {
        product: product,
        article: {
          id: defaultArticle.id,
        },
      };

      let oig = {
        location: this.$store.state.location,
        dateStart: this.$store.state.checkInDate,
        dateEnd: this.$store.state.checkInDate,
        itemsCount: 1,
        numberOfPersons: product.minNumOfPersons,
        length: 1,
        priceListType: "HOURLY",
        price: 0,
        dph: 0,
        dphPercent: 0,
        subjectProfile: null,
        product: product, // hlavni produkt
        set: null, // indikator setu
        orderrItems: [oi],
      };

      this.orderrItemGroup = oig;

      for (let i = 0; i < product.minNumOfPersons; i++) {
        this.coursePersons.push({ name: null, age: null });
      }
    },

    async bookItem() {
      // zkontrolovat, jesli jsem prihlasen
      if (this.$store.state.user == null) {
        this.$emit("loginRequest");
        return;
      }

      this.submiting = true;
      console.log("zarezervuj polozku");

      // lessons
      let lessons = [];
      for (let i = 0; i < this.selectedLessons.length; i++) {
        let selectedLesson = this.selectedLessons[i];
        let lessonIn = {
          groups: this.$store.state.appInstance,
          appInstance: this.$store.state.appInstance,
          mobVersion: this.$store.state.mobConfig.mobVersion,
          mssId: null,
          mssWorkDayId: selectedLesson.sganttWorkDayMssId,
          timeFrom: selectedLesson.start,
          timeTo: selectedLesson.end,
          timeLength: selectedLesson.timeLength,
        };
        lessons.push(lessonIn);
      }

      this.orderrItemGroup.description = this.oigDescription;

      this.orderrItemGroup.orderrItems[0].lessons = lessons;
      this.orderrItemGroup.orderrItems[0].language = this.language;
      this.orderrItemGroup.orderrItems[0].skillLevelClient =
        this.skillLevelClient;
      this.orderrItemGroup.orderrItems[0].sameInstructorRequired = true;
      this.orderrItemGroup.orderrItems[0].numberOfHoursRequired =
        this.numberOfHoursRequired;

      try {
        await this.$store.dispatch("addToCart", this.orderrItemGroup);
        // notifikace
        // nabidnout prejit do kosiku nebo dale vybirat
        this.dialog = true;
      } catch (e) {
        console.error("Pridani do kosiku se nepovedlo");
        console.log(e);
      }

      this.submiting = false;
    },

    goToCourseSearch() {
      this.dialog = false;
      this.$router.push({ name: "course-search" });
    },

    goToCart() {
      this.dialog = false;
      this.$router.push({ name: "cart" });
    },

    subjectProfileChangeHandler(subjectProfile) {
      this.orderrItemGroup.subjectProfile = subjectProfile;
    },

    lessonsChangeHandler(lessons) {
      console.log("lessonsChangeHandler");
      console.log(lessons);
      this.selectedLessons = lessons;
      this.orderrItemGroup.length = this.lengthSum;
    },
  },
};
</script>
